import { render, staticRenderFns } from "./CouponGroup.vue?vue&type=template&id=5d7ec698"
import script from "./CouponGroup.vue?vue&type=script&lang=ts"
export * from "./CouponGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports